import { Component, Input } from '@angular/core';

@Component({
  selector: 'common-instagram-icon',
  templateUrl: './instagram-icon.component.svg',
})
export class InstagramIconComponent {
  @Input() color = '#343E57';
  @Input() width = 20;
  @Input() height = 20;
}
